import {FormattedProperty, getRawPropertyName} from 'common/util/format-property';
import {MessageMediaType} from 'common/report/util/profile/types';

export function getVisibleProperties(
  properties: Map<string, FormattedProperty>,
  propertiesToHide: string[],
): FormattedProperty[] {
  return Array.from(properties.values()).filter((property) => !propertiesToHide.includes(getRawPropertyName(property)));
}

export function formatMessageMedia(messageMedia: MessageMediaType): string {
  switch (messageMedia) {
    case MessageMediaType.Email:
      return `Email`;
    case MessageMediaType.Push:
      return `Push`;
    default:
      throw new Error(`Unknown Message Media Type: ${messageMedia}`);
  }
}
